export default __webpack_public_path__ + "static/media/elevate-red-banner-3.2b26886c.jpg";